import { Box } from "@mui/material";
import { useContext, useState } from "react";
import { LanguageContext } from "../../../context/LanguageContext";
import { ParagraphText, UBOTPInput } from "../../../Libraries";
import { analytics, triggerLogEvent } from "../../../config/firebase";
import styles from "./styles.module.css"

const PINScreen = ({
  onChangeQuery,
  title,
  description,
  error,
  id
}) => {
  const [PIN, setPIN] = useState("");
  const [I18n] = useContext(LanguageContext);

  const onChange = (value) => {
    setPIN(value);
    if (PIN.length === 0 && value.length >= 1) {
      triggerLogEvent(analytics, "login_pin_enter");
    }
    if (value.length === 4) {
      onChangeQuery(value);
    }
  };
  return (
    <Box className={styles.verifyPinContainer}>
      
      <Box className={styles.verifyPinHeaderContainer} >
      <ParagraphText className={`fontSize24 fontWeight500`} id={`${id}_id`}>
        {title || I18n.enter_current_pin}
      </ParagraphText>
      <ParagraphText className={"fontSize14 fontWeight400"}>
        {description || I18n.please_enter_your_4_digits_PIN_to_contine}
      </ParagraphText>
      </Box>

      <UBOTPInput
        id="enter_pin_input"
        label={I18n.enter_pin}
        className="marginTop40"
        value={PIN}
        onChangeQuery={onChange}
        shouldAutoFocus
        invalid={!!error}
        helperText={error}
        isInputSecure={true}
      />
    </Box>
  );
};
export default PINScreen;
